module.exports = __webpack_public_path__ + "static/media/Selected.f6d4ccb9.svg";